import { ComponentEx, translate } from "./ComponentEx";
import Overlay from "./Overlay";
import { IconButton } from "./TooltipControls";
import * as React from "react";
import { Popover } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
const haveKnowledgeBase = (() => {
    let value;
    return (api) => {
        if (value === undefined) {
            // is this expensive? Is it worth caching?
            value = api.events.listenerCount("open-knowledge-base") > 0;
        }
        return value;
    };
})();
/**
 * Component to make additional information available to the user without taking much
 * space. The user only sees a clickable question mark. On click it will show a popover
 * with the info.
 *
 * double-linebreaks can be used in the text to start a new paragraph.
 *
 * @param {IProps} props
 * @returns
 */
class More extends ComponentEx {
    mRef;
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }
    render() {
        const { t, children, id, name, orientation, wikiId } = this.props;
        const { open } = this.state;
        if (children === undefined) {
            return null;
        }
        const wikiFooter = wikiId === undefined || !haveKnowledgeBase(this.context.api) ? null : (React.createElement("div", { className: "more-footer" },
            React.createElement("a", { href: `#${wikiId}`, onClick: this.openWiki }, t("Learn more"))));
        let pCounter = 0;
        const popover = (React.createElement(Popover, { id: `popover-${id}`, className: "more-popover", title: name },
            React.createElement(ReactMarkdown, null, children),
            wikiFooter));
        return (React.createElement("div", { style: { display: "inline" } },
            React.createElement(Overlay, { rootClose: true, show: open, onHide: this.hide, orientation: orientation, target: this.getRef, getBounds: this.getBounds }, popover),
            React.createElement("div", { className: "more-link", ref: this.setRef },
                React.createElement(IconButton, { tooltip: "", onClick: this.toggle, icon: "details" }))));
    }
    getRef = () => this.mRef;
    setRef = (ref) => {
        this.mRef = ref;
    };
    openWiki = (evt) => {
        this.context.api.events.emit("open-knowledge-base", evt.currentTarget.getAttribute("href").slice(1));
        this.hide();
    };
    toggle = (evt) => {
        evt.preventDefault();
        this.setState({ open: !this.state.open });
    };
    hide = () => {
        this.setState({ open: false });
    };
    getBounds = () => {
        const { container } = this.props;
        return container !== undefined
            ? container.getBoundingClientRect()
            : {
                left: 0,
                top: 0,
                width: window.innerWidth,
                height: window.innerHeight,
                right: window.innerWidth,
                bottom: window.innerHeight,
            };
    };
}
export default translate(["common"])(React.memo(More));
